var exports = {
  "jC": "AddOverridePopout.module__popoutContainer___V1ZkZ1",
  "MT": "AddOverridePopout.module__searchContainer___V1ZkZ1",
  "XG": "AddOverridePopout.module__scroller___V1ZkZ1",
  "uW": "AddOverridePopout.module__section___V1ZkZ1",
  "bV": "AddOverridePopout.module__sectionHeader___V1ZkZ1",
  "k0": "AddOverridePopout.module__itemButton___V1ZkZ1",
  "CB": "AddOverridePopout.module__roleIndicator___V1ZkZ1",
  "IR": "AddOverridePopout.module__itemLabel___V1ZkZ1",
  "my": "AddOverridePopout.module__avatar___V1ZkZ1",
  "p$": "AddOverridePopout.module__emptyState___V1ZkZ1",
};

module.exports = exports;
